import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import Reveal from "./Reveal";

export default function CtaBand({
  title = "Put senior delivery people on the programme that can't slip.",
  text = "Tell us what you need to land. We'll show you how we'd deliver it — or review whether it's on track.",
  primaryLabel = "Start a conversation",
  primaryTo = "/contact",
  showEmail = true,
}) {
  return (
    <section className="relative overflow-hidden bg-[#0B1F3A]" data-testid="cta-band">
      <img
        src="https://images.unsplash.com/photo-1758518729685-f88df7890776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBidXNpbmVzcyUyMGNvbnN1bHRpbmclMjB0ZWFtJTIwbWVldGluZyUyMG1vZGVybiUyMG9mZmljZXxlbnwwfHx8fDE3ODkxNDg1OTV8MA&ixlib=rb-4.1.0&q=80&w=1600"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-[0.14]"
      />
      <div className="absolute inset-0 bg-[#0B1F3A]/60" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24">
        <Reveal className="max-w-3xl">
          <h2 className="text-balance font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="cta-band-title">
            {title}
          </h2>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/70">{text}</p>
          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Link
              to={primaryTo}
              data-testid="cta-band-button"
              className="group inline-flex items-center gap-2 rounded-md bg-[#C9A227] px-7 py-3.5 text-sm font-bold text-[#0B1F3A] transition-colors duration-200 hover:bg-[#DDB845]"
            >
              {primaryLabel}
              <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
            {showEmail && (
              <a
                href="mailto:takunda.noha@incrementalconsulting.co.za"
                data-testid="cta-band-email"
                className="inline-flex items-center gap-2 rounded-md border border-white/30 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:border-[#C9A227] hover:text-[#C9A227]"
              >
                <Mail size={15} />
                takunda.noha@incrementalconsulting.co.za
              </a>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
